import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=0760baa1&scoped=true&"
import script from "./apps.vue?vue&type=script&lang=js&"
export * from "./apps.vue?vue&type=script&lang=js&"
import style0 from "./apps.vue?vue&type=style&index=0&id=0760baa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0760baa1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0760baa1')) {
      api.createRecord('0760baa1', component.options)
    } else {
      api.reload('0760baa1', component.options)
    }
    module.hot.accept("./apps.vue?vue&type=template&id=0760baa1&scoped=true&", function () {
      api.rerender('0760baa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/apps/apps.vue"
export default component.exports